export default "__VITE_ASSET__DFCsx7dw__"